import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const AddAgeRecommendationRule = ({ isOpen, onRequestClose, companyId }) => {
  const [operator, setOperator] = useState(">");
  const [conditionValue, setConditionValue] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!conditionValue || isNaN(conditionValue)) {
      toast.error("Please enter a valid age value.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    try {
      await axios.post(
        "/api/recommendationrules/create",
        {
          companyId,
          ruleName: "AGE",
          operator,
          conditionValue: parseFloat(conditionValue),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Age Recommendation Rule added successfully!");
      setOperator(">");
      setConditionValue("");
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">rule</i>
          Add Age-Based Recommendation Rule
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label small fw-semibold">
              Operator <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={operator}
              onChange={(e) => setOperator(e.target.value)}
              required
            >
              <option value=">">&gt; (Greater Than)</option>
              <option value="<">&lt; (Less Than)</option>
              <option value=">=">&ge; (Greater Than or Equal)</option>
              <option value="<=">&le; (Less Than or Equal)</option>
              <option value="=">= (Equal)</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="form-label small fw-semibold">
              Age Threshold (Years) <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              type="number"
              step="1"
              min="0"
              max="120"
              placeholder="e.g., 40"
              value={conditionValue}
              onChange={(e) => setConditionValue(e.target.value)}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>save</i>
              Save Rule
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddAgeRecommendationRule;
